// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Feedback-module__columnText--UtsC7 {
    display: flex;
    flex-direction: column;
}

.Feedback-module__title--sE79N {
    color: #6F879C;
    font-size: 20px;
    font-weight: 400;
    border-bottom: 1px solid #6f879c4b;
}

.Feedback-module__infoText--_iFmg>.Feedback-module__icon--J5rI6 {
    color: #0054E6;
}

.Feedback-module__infoText--_iFmg {
    margin: 0 10px 20px;
    color: #516372;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.Feedback-module__link--vq02c {
    text-decoration: none;
}

.Feedback-module__contentBox--SCbvO {
    display: flex;
    gap: 40px;
    justify-content: center;
    align-items: center;
    height: 40vh;
}

@media (max-width: 800px) {
    .Feedback-module__contentBox--SCbvO {
        display: flex;
        flex-direction: column;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/feedback/Feedback.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;IAC1B;;AAEJ","sourcesContent":[".columnText {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.title {\r\n    color: #6F879C;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n    border-bottom: 1px solid #6f879c4b;\r\n}\r\n\r\n.infoText>.icon {\r\n    color: #0054E6;\r\n}\r\n\r\n.infoText {\r\n    margin: 0 10px 20px;\r\n    color: #516372;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 20px;\r\n}\r\n\r\n.link {\r\n    text-decoration: none;\r\n}\r\n\r\n.contentBox {\r\n    display: flex;\r\n    gap: 40px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 40vh;\r\n}\r\n\r\n@media (max-width: 800px) {\r\n    .contentBox {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"columnText": `Feedback-module__columnText--UtsC7`,
	"title": `Feedback-module__title--sE79N`,
	"infoText": `Feedback-module__infoText--_iFmg`,
	"icon": `Feedback-module__icon--J5rI6`,
	"link": `Feedback-module__link--vq02c`,
	"contentBox": `Feedback-module__contentBox--SCbvO`
};
export default ___CSS_LOADER_EXPORT___;
